import React from 'react'
import Doctor from '../../Components/Admin/Doctor/Doctor'

const AdminDoctorPage = () => {
  return (
    <div className='p-5'>
      <Doctor />
    </div>
  )
}

export default AdminDoctorPage
